<template>
    <DefaultTemplate :model="model">
        <div class="container">
            <div class="mt-12 mb-8">
                <Breadcrumbs :breadcrumbs="model.breadcrumbs" className="text-grey-400" />
            </div>

            <div class="block lg:flex">
                <div class="w-full lg:w-3/4 pr-0 lg:pr-4">
                    <article class="p-4 md:px-10 md:py-4 lg:px-20 lg:py-10 mb-4 bg-white">
                        <h1 v-epi-edit="'Name'" class="mb-2">
                            {{ model.name }}
                        </h1>

                        <hr class="my-4 lg:my-10" />

                        <ContentArea v-epi-edit="'LeftContentArea'" :model="model.leftContentArea" />
                    </article>
                </div>
                <aside class="w-full lg:w-1/4 pr-0 lg:pl-4 mb-4">
                    <div class="p-5 mb-6 bg-white">
                        <ContentArea v-epi-edit="'RightContentArea'" :model="model.rightContentArea" />
                    </div>

                    <div class="flex justify-end mt-6">
                        <Sharing />
                    </div>
                </aside>
            </div>
        </div>
    </DefaultTemplate>
</template>

<script>
import Breadcrumbs from '@/Scripts/components/organisms/Breadcrumbs/breadcrumbs.vue';
import ContentArea from '@/Scripts/components/ContentArea.vue';
import Sharing from '@/Scripts/components/atoms/Sharing/Sharing.vue';

export default {
    props: ['model'],
    components: {
        Breadcrumbs,
        ContentArea,
        Sharing
    }
};
</script>
